var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.layoutPrincipal.navBar,{tag:"component"}),_c('main',{staticStyle:{"min-height":"80dvh"}},[_c('router-view')],1),_c(_vm.layoutPrincipal.footer,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }